import { render, staticRenderFns } from "./DispatchPositionTable.vue?vue&type=template&id=4f06bd28&scoped=true&"
import script from "./DispatchPositionTable.vue?vue&type=script&lang=js&"
export * from "./DispatchPositionTable.vue?vue&type=script&lang=js&"
import style0 from "./DispatchPositionTable.vue?vue&type=style&index=0&id=4f06bd28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f06bd28",
  null
  
)

export default component.exports